import LabelProvider from "core/components/label/LabelProvider";

export default LabelProvider.create({

	/**
	 * from react-big-calendar
	 *
	 * date,time,event,allDay,week,work_week,day,
	 * month,previous,next,yesterday,tomorrow,today,
	 * agenda,noEventsInRange,showMore
	 */

	Agenda: { k: "agenda", v: "Agenda" },

	AllDay: { k: "allDay", v: "All Day" },

	Date: { k: "date", v: "Date" },

	Day: { k: "day", v: "Day" },

	Event: { k: "event", v: "Event" },

	Month: { k: "month", v: "Month" },

	Next: { k: "next", v: "Next" },

	NoEventsInRange: { k: "noEventsInRange", v: "There are no events in this range." },

	Previous: { k: "previous", v: "Back" },

	Time: { k: "time", v: "Time" },

	Today: { k: "today", v: "Today" },

	Tomorrow: { k: "tomorrow", v: "Tomorrow" },

	Week: { k: "week", v: "Week" },

	WorkWeek: { k: "work_week", v: "Work Week" },

	Yesterday: { k: "yesterday", v: "Yesterday" }

});



// WEBPACK FOOTER //
// ./src/common/views/calendar/labels.ts